import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Spatial structures used by the institution, such as Campuses, Buildings, and Rooms',
    name: 'Space',
    partialId: PartialId.Standard.create('space'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
